import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
/** reset browser button style */
export function nonStyleButton() {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit;\n  "], ["\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit;\n  "])));
}
var templateObject_1;
